/**
 * This mixin can be included in Vuex modules to display and update a progress
 * modal when performing large batches XHR requests or other iterative work
 * that should display progress indicator for the user.
 *
 * For an example of using the ProgressMixin please see the deleteItems action
 * in:
 *
 * /client/store/modules/collections/GroupCollection.js
 *
 * @todo Until the ProgressModal is refactored to be a Vue component that is
 * rendered in TheModal, components that need to display a progress modal will
 * need to render the ProgressModal component as seen in:
 *
 * /client/components/ItemTable/GroupItemTable.vue
 */
export default {
  actions: {
    setCounter({ dispatch }, { completed, total }) {
      dispatch('ProgressModule/setCounter', { completed, total }, { root: true });
    },

    incrementCompleted({ dispatch }) {
      dispatch('ProgressModule/incrementCompleted', {}, { root: true });
    },

    updateBulkActionStatus({ dispatch }, status) {
      dispatch('ProgressModule/updateBulkActionStatus', status, { root: true });
    },
  },
};
